/* Authentication Modal Component */

import { authenticateUser } from '../utils/auth';
import React from 'react';

import '../css/kiosk.css'; // Assuming you have a CSS file for styling
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'reactstrap';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAuthSuccess: (user: any) => void; // Callback for successful authentication
}

const AuthModal = ({ isOpen, onClose, onAuthSuccess }:AuthModalProps) => {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  
  // Handle form submission
  const handleSubmit = async (e:any) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    try {
      const result = await authenticateUser(username, password);
      setUsername('');
      setPassword('');
      
      if (result.success) {
        onAuthSuccess(result.user);
        onClose();

      } else {
        setError(result.error || 'Authentication failed');
      }
    } catch (err) {
      setError('An error occurred during authentication');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  
  if (!isOpen) return null;
  
  return (
    <Modal isOpen={isOpen} toggle={onClose} className="auth-modal">
        <form onSubmit={handleSubmit}>
          {error && <div className="auth-error">{error}</div>}
          
          <div className="modal-form-group">
            <label className="modal-label" htmlFor="username">Username</label>
            <input 
              id="username"
              className="modal-input" 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
            />
          </div>
          
          <div className="modal-form-group">
            <label className="modal-label" htmlFor="password">Password</label>
            <input 
              id="password"
              className="modal-input" 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          
          <div className="modal-actions">
            <button 
              type="button" 
              className="modal-button secondary" 
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="modal-button primary" 
              disabled={isLoading || !username || !password}
            >
              {isLoading ? 'Authenticating...' : 'Login'}
            </button>
          </div>
        </form>
    </Modal>
  );
};

export default AuthModal;